import AntLocalStorage from './AntLocalStorage';
import { applyMarketOverride } from '../data/currencyMarketDigits';

import { locale, loadMessages } from 'devextreme/localization';
import lang_ar from 'devextreme/localization/messages/ar.json';
import lang_ca from 'devextreme/localization/messages/ca.json';
import lang_cs from 'devextreme/localization/messages/cs.json';
import lang_de from 'devextreme/localization/messages/de.json';
import lang_el from 'devextreme/localization/messages/el.json';
import lang_en from 'devextreme/localization/messages/en.json';
import lang_es from 'devextreme/localization/messages/es.json';
import lang_fi from 'devextreme/localization/messages/fi.json';
import lang_fr from 'devextreme/localization/messages/fr.json';
import lang_hu from 'devextreme/localization/messages/hu.json';
import lang_it from 'devextreme/localization/messages/it.json';
import lang_ja from 'devextreme/localization/messages/ja.json';
import lang_lt from 'devextreme/localization/messages/lt.json';
import lang_nb from 'devextreme/localization/messages/nb.json';
import lang_nl from 'devextreme/localization/messages/nl.json';
import lang_pt from 'devextreme/localization/messages/pt.json';
import lang_ro from 'devextreme/localization/messages/ro.json';
import lang_ru from 'devextreme/localization/messages/ru.json';
import lang_sl from 'devextreme/localization/messages/sl.json';
import lang_sv from 'devextreme/localization/messages/sv.json';
import lang_tr from 'devextreme/localization/messages/tr.json';
import lang_vi from 'devextreme/localization/messages/vi.json';
import lang_zh_tw from 'devextreme/localization/messages/zh-tw.json';
import lang_zh from 'devextreme/localization/messages/zh.json';

import currencies from '../data/currencies.json';
// Arabic	`lib/ar_AE.json`	1.0.0
// Chinese (simplified)	`lib/zh_CN.json`	1.0.0
// Chinese (traditional)	`lib/zh_TW.json`	1.0.0
// English	`lib/en_US/json`	1.0.0
// French	`lib/fr_FR.json`	1.0.0
// German	`lib/de_DE.json`	1.0.0
// Italian	`lib/it_IT.json`	1.0.0
// Japanese	`lib/jp_JP.json`	1.0.0
// Korean	`lib/ko_KR.json`	1.0.0
// Portuguese	`lib/pt_PT.json`	1.0.0
// Russian	`lib/ru_RU.json`	1.0.0
// Spanish	`lib/es_ES.json`	1.0.0
// Vietnamese	`lib/vi_VN.json`	1.0.0

export default {
    initLanguage() {
        var language = AntLocalStorage.getBusinessSetting('Sys_BaseLanguage');
        language = String(language).split('-')[0];

        if (language === 'ar') loadMessages(lang_ar);
        else if (language === 'ca') loadMessages(lang_ca);
        else if (language === 'cs') loadMessages(lang_cs);
        else if (language === 'de') loadMessages(lang_de);
        else if (language === 'el') loadMessages(lang_el);
        else if (language === 'en') loadMessages(lang_en);
        else if (language === 'es') loadMessages(lang_es);
        else if (language === 'fi') loadMessages(lang_fi);
        else if (language === 'fr') loadMessages(lang_fr);
        else if (language === 'hu') loadMessages(lang_hu);
        else if (language === 'it') loadMessages(lang_it);
        else if (language === 'ja') loadMessages(lang_ja);
        else if (language === 'lt') loadMessages(lang_lt);
        else if (language === 'nb') loadMessages(lang_nb);
        else if (language === 'nl') loadMessages(lang_nl);
        else if (language === 'pt') loadMessages(lang_pt);
        else if (language === 'ro') loadMessages(lang_ro);
        else if (language === 'ru') loadMessages(lang_ru);
        else if (language === 'sl') loadMessages(lang_sl);
        else if (language === 'sv') loadMessages(lang_sv);
        else if (language === 'tr') loadMessages(lang_tr);
        else if (language === 'vi') loadMessages(lang_vi);
        else if (language === 'zh-tw') loadMessages(lang_zh - tw);
        else if (language === 'zh') loadMessages(lang_zh);
        else loadMessages(lang_en);

        locale(language);
    },
    formatCurrency(showSign) {
        var language = AntLocalStorage.getBusinessSetting('Sys_BaseLanguage');
        var currency = AntLocalStorage.getSetting('Sys_BaseCurrency');
        var showSymbol = AntLocalStorage.getSetting('Sys_BaseCurrency_Show_Symbol');

        // if (currency === 'VND') language = 'vi';

        return { language: language, style: showSymbol ? 'currency' : undefined, currency: currency, signDisplay: showSign ? 'always' : 'auto' };
    },

    getNumberSeparators() {
        var language = AntLocalStorage.getBusinessSetting('Sys_BaseLanguage');
        var currency = AntLocalStorage.getSetting('Sys_BaseCurrency');
        if (!currency) currency = 'USD';

        let found = currencies.find((c) => c.code === currency);
        if (found) language = found.locale;
        if (!language) language = 'en-US';

        const formatter = new Intl.NumberFormat(language);

        // Lấy các phần định dạng của số thập phân
        const parts = formatter.formatToParts(12345.6);

        const groupPart = parts.find((p) => p.type === 'group');
        const decimalPart = parts.find((p) => p.type === 'decimal');

        return {
            thousands: groupPart ? groupPart.value : '.', // mặc định nếu không tìm thấy
            decimal: decimalPart ? decimalPart.value : ','
        };
    },
    // Resolve currency cho 1 field/column theo chain:
    //   1. spec.keepBaseCurrency:true → Sys_BaseCurrency (chặn override)
    //   2. spec.currency literal → fixed
    //   3. spec.currencyField → row[field] || parent[field]
    //   4. defaultCurrencyField (form/grid prop) → row[field] || parent[field]
    //   5. fallback → Sys_BaseCurrency
    // spec = { currency?, currencyField?, keepBaseCurrency? } (lấy từ field/column.options.currency)
    resolveCurrency(spec, row, parent, defaultCurrencyField) {
        var base = AntLocalStorage.getSetting('Sys_BaseCurrency');
        if (spec && spec.keepBaseCurrency) return base;
        if (spec && spec.currency) return spec.currency;
        var field = spec && spec.currencyField ? spec.currencyField : defaultCurrencyField;
        if (field) {
            if (row && row[field]) return row[field];
            if (parent && parent[field]) return parent[field];
        }
        return base;
    },
    getCurrencySymbol(opts) {
        var showSymbol = AntLocalStorage.getSetting('Sys_BaseCurrency_Show_Symbol');
        var base = AntLocalStorage.getSetting('Sys_BaseCurrency');
        var currency = opts && opts.currency ? opts.currency : base;
        var isForeign = base && currency && currency !== base;
        var forceCode = isForeign && !showSymbol;

        if (!currency || (!showSymbol && !forceCode))
            return {
                symbol: '',
                isPrefix: true
            };

        // Setting OFF + foreign currency → force show currency CODE as suffix
        if (forceCode)
            return {
                symbol: currency,
                isPrefix: false
            };

        if (currency === 'VND')
            return {
                symbol: 'đ',
                isPrefix: false
            };

        var language = AntLocalStorage.getBusinessSetting('Sys_BaseLanguage');
        let found = currencies.find((c) => c.code === currency);
        if (found) language = found.locale;
        if (!language) language = 'en-US';

        try {
            const formatter = new Intl.NumberFormat(language, {
                style: 'currency',
                currency: currency,
                currencyDisplay: 'narrowSymbol'
            });

            // Lấy các phần của định dạng
            const parts = formatter.formatToParts(1);

            // Lấy ký hiệu tiền tệ
            const symbolPart = parts.find((p) => p.type === 'currency');
            const symbol = symbolPart ? symbolPart.value : '';

            // Kiểm tra symbol ở trước hay sau số
            const isPrefix = parts.findIndex((p) => p.type === 'currency') < parts.findIndex((p) => p.type === 'integer');

            return {
                symbol,
                isPrefix // true = trước số, false = sau số
            };
        } catch (error) { }

        return {
            symbol: '',
            isPrefix: true
        };
    },
    getCurrencyDecimalDigit(opts) {
        var currency = opts && opts.currency ? opts.currency : AntLocalStorage.getSetting('Sys_BaseCurrency');
        if (!currency) currency = 'USD';

        let digit = 2;

        let found = currencies.find((c) => c.code === currency);
        if (found) digit = found.digit;
        if (digit === null || digit === undefined) digit = 2;

        // Áp ghi đè theo thị trường để màn hình khớp đúng cách máy chủ làm tròn.
        // Không có bước này thì doanh nghiệp Indonesia hiện 2 số lẻ trong khi máy chủ tính 0.
        return applyMarketOverride(digit, currency, AntLocalStorage.getSetting('Sys_BaseCountry'));
    },
    getCurrencyFormat(opts) {
        var showSymbol = AntLocalStorage.getSetting('Sys_BaseCurrency_Show_Symbol');
        showSymbol = Boolean(showSymbol) && showSymbol !== 'null' && showSymbol !== 'undefined';

        var base = AntLocalStorage.getSetting('Sys_BaseCurrency');
        var currency = opts?.currency ? opts?.currency : base;
        if (!currency) return '#,##0.##';

        var isForeign = base && currency && currency !== base;
        var forceCode = isForeign && !showSymbol;

        // if (currency === 'VND') return '#,##0 đ';

        var language = AntLocalStorage.getBusinessSetting('Sys_BaseLanguage');
        let found = currencies.find((c) => c.code === currency);
        if (found) language = found.locale;
        if (!language) language = 'en-US';

        let digit = 2;
        if (found) digit = found.digit;
        if (digit === null || digit === undefined) digit = 2;

        let decimalPart = '';
        if (digit > 0) {
            decimalPart = '.' + '#'.repeat(digit);
        }

        // Setting OFF + foreign currency → force show currency CODE as suffix
        if (forceCode) return '#,##0' + decimalPart + ' ' + currency;

        try {
            const formatter = new Intl.NumberFormat(language, {
                style: 'currency',
                currency: currency,
                currencyDisplay: opts?.currencyDisplay ? opts?.currencyDisplay : 'narrowSymbol'
            });

            const parts = formatter.formatToParts(1);
            const symbolPart = parts.find((p) => p.type === 'currency');

            // VND hiển thị "đ" đặt sau số — cùng quy ước với getCurrencySymbol/translateCurrency (Intl trả "₫")
            const isVND = currency === 'VND';
            const symbol = isVND ? 'đ' : symbolPart ? symbolPart.value : '';

            const isPrefix =
                opts?.isPrefix !== null && opts?.isPrefix !== undefined
                    ? opts?.isPrefix
                    : isVND
                    ? false
                    : parts.findIndex((p) => p.type === 'currency') < parts.findIndex((p) => p.type === 'integer');
            if (isPrefix) {
                if (showSymbol) return symbol + ' #,##0' + decimalPart;
                else return '#,##0' + decimalPart;
            } else {
                if (showSymbol) return '#,##0' + decimalPart + ' ' + symbol;
                else return '#,##0' + decimalPart;
            }
        } catch (error) { }

        return '#,##0.##';
    },
    translateCurrency(value, showSign, opts) {
        if (isNaN(value)) value = 0;

        if (value instanceof Array) return value;

        var showSymbol = AntLocalStorage.getSetting('Sys_BaseCurrency_Show_Symbol');
        var language = AntLocalStorage.getBusinessSetting('Sys_BaseLanguage');
        var base = AntLocalStorage.getSetting('Sys_BaseCurrency');
        var currency = opts && opts.currency ? opts.currency : base;

        if (!currency) return value;

        var isForeign = base && currency && currency !== base;
        var forceCode = isForeign && !showSymbol;

        let found = currencies.find((c) => c.code === currency);
        if (found) language = found.locale;
        if (!language) language = 'en-US';

        let digit = 2;
        if (found) digit = found.digit;
        if (digit === null || digit === undefined) digit = 2;

        // Setting OFF + foreign currency → force show currency CODE as suffix
        if (forceCode) {
            let formatter = new Intl.NumberFormat(language, {
                style: 'decimal',
                minimumFractionDigits: digit,
                maximumFractionDigits: digit
            });
            let srtValue = '';
            if (showSign) {
                let oValue = value > 0 ? -parseFloat(value) : value;
                srtValue = formatter.format(oValue);
                if (value > 0) srtValue = srtValue.replaceAll('-', '+');
            } else {
                srtValue = formatter.format(value);
            }
            return srtValue + ' ' + currency;
        }

        if (!showSymbol) {
            let formatter = new Intl.NumberFormat(language, {
                style: 'decimal',
                minimumFractionDigits: digit,
                maximumFractionDigits: digit
            });

            var srtValue = '';
            if (showSign) {
                let oValue = value > 0 ? -parseFloat(value) : value;
                srtValue = formatter.format(oValue);
                if (value > 0) srtValue = srtValue.replaceAll('-', '+');
            } else {
                srtValue = formatter.format(value);
            }
            return srtValue;
        } else {
            try {
                let formatter = new Intl.NumberFormat(language, {
                    style: 'currency',
                    currency: currency,
                    signDisplay: showSign ? 'always' : 'auto',
                    currencyDisplay: 'narrowSymbol'
                });

                var srtValue = '';
                if (showSign) {
                    let oValue = value > 0 ? -parseFloat(value) : value;
                    srtValue = formatter.format(oValue);
                    if (value > 0) srtValue = srtValue.replaceAll('-', '+');
                } else {
                    srtValue = formatter.format(value);
                }

                if (currency === 'VND') {
                    srtValue = srtValue.replaceAll('₫', '').trim();
                    // srtValue = srtValue.replaceAll(',', '.');
                    if (showSymbol) srtValue = srtValue + ' đ';
                }

                // console.log('ant-log-srtValue : ', value, language, showSymbol, srtValue);
                return srtValue;
            } catch (error) { }
        }
        return value;
    },

    translateInteger(value, showSign) {
        if (isNaN(value)) value = 0;

        if (value instanceof Array) return value;

        var language = AntLocalStorage.getBusinessSetting('Sys_BaseLanguage');
        var currency = AntLocalStorage.getSetting('Sys_BaseCurrency');

        if (currency) {
            let found = currencies.find((c) => c.code === currency);
            if (found) language = found.locale;
        }
        if (!language) language = 'en-US';

        var srtValue;

        if (showSign) {
            let oValue = value > 0 ? -parseFloat(value) : value;
            srtValue = new Intl.NumberFormat(language, {
                signDisplay: 'always'
            }).format(oValue);

            if (value > 0) srtValue = srtValue.replaceAll('-', '+');
        } else {
            srtValue = new Intl.NumberFormat(language, {
                signDisplay: showSign ? 'always' : 'auto'
            }).format(value);
        }

        return srtValue;
    },

    translateDecimal(value, showSign) {
        if (isNaN(value)) value = 0;

        if (value instanceof Array) return value;

        var language = AntLocalStorage.getBusinessSetting('Sys_BaseLanguage');
        var currency = AntLocalStorage.getSetting('Sys_BaseCurrency');

        if (currency) {
            let found = currencies.find((c) => c.code === currency);
            if (found) language = found.locale;
        }
        if (!language) language = 'en-US';

        var srtValue;

        if (showSign) {
            let oValue = value > 0 ? -parseFloat(value) : value;
            srtValue = new Intl.NumberFormat(language, {
                style: 'decimal',
                signDisplay: 'always'
            }).format(oValue);

            if (value > 0) srtValue = srtValue.replaceAll('-', '+');
        } else {
            srtValue = new Intl.NumberFormat(language, {
                style: 'decimal',
                signDisplay: showSign ? 'always' : 'auto'
            }).format(value);
        }

        return srtValue;
    },

    translateText(value) {
        if (value instanceof Array) return value;

        if (typeof value === 'object' && Boolean(value)) {
            var language = AntLocalStorage.getBusinessSetting('Sys_BaseLanguage');
            if (language && value[language]) return value[language];

            language = String(language).split('-')[0];
            if (language && value[language] !== undefined) return value[language];

            // if (language === 'en' && value.en) return value.en;
            // if (language === 'fr' && value.fr) return value.fr;
            // if (language === 'es' && value.es) return value.es;
            // if (language === 'zh' && value.zh) return value.zh;
            // if (language === 'ja' && value.ja) return value.ja;
            // if (language === 'ko' && value.ko) return value.ko;
            // if (language === 'ru' && value.ru) return value.ru;
            // if (language === 'it' && value.it) return value.it;

            if (value.vi) return value.vi;
            if (value.en) return value.en;
            
            return String(value);
        }
        return value;
    }
};
